<template>
  <section id="section-3" class="content-current">
    <div class="row">
      <div class="col-md-11"></div>
      <div class="col-md-1">
        <router-link to="/profile/dashboard">
          <div title="بازگشت به داشبورد" class="close"></div>
        </router-link>
      </div>
    </div>
    <table class="table tablesorter  add_bottom_30">
      <thead class="thead-light">
        <tr>
          <th>شماره رزرو</th>
          <th>تاریخ ثبت</th>
          <th>نام مهمان</th>
          <th>نام هتل</th>
          <th>ورود</th>
          <th>خروج</th>
          <th>وضعیت پرداخت</th>
          <th>فروشنده</th>
          <th>کد فروشنده</th>
          <th>روش پرداخت</th>
          <th>هزینه کل</th>
          <th>مشاهده واچر</th>
          <th>وضعیت کنسل</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Louvre Museum ticket</td>
          <td>test</td>
          <td>امیر محمد فیروزی</td>
          <td>هتل داریوش کیش</td>
          <td>1399/07/03</td>
          <td>1399/07/03</td>
          <td>پرداخت نشده</td>
          <td>تست رزرو واحد فنی</td>
          <td>10</td>
          <td>پرداخت نشده</td>
          <td>10,800,000</td>

          <td>
            <strong>€24,71</strong>
          </td>
          <td class="options">کنسل</td>
        </tr>
        <tr>
          <td>
            <span class="item_cart">Louvre Museum tickets</span>
          </td>
          <td>
            <div class="numbers-row">test</div>
          </td>
          <td>تست asdasd</td>
          <td>هتل داریوش کیش</td>
          <td>1399/07/03</td>
          <td>1399/07/03</td>
          <td>پرداخت نشده</td>
          <td>تست رزرو واحد فنی</td>
          <td>10</td>
          <td>پرداخت نشده</td>
          <td>10,800,000</td>

          <td>
            <strong>€24,71</strong>
          </td>
          <td class="options"><a href="#"></a><a href="#"></a></td>
        </tr>
        <tr>
          <td>
            <span class="item_cart">Louvre Museum tickets</span>
          </td>
          <td>
            <div class="numbers-row">test</div>
          </td>
          <td>تست asdasd</td>
          <td>هتل داریوش کیش</td>
          <td>1399/07/03</td>
          <td>1399/07/03</td>
          <td>پرداخت نشده</td>
          <td>تست رزرو واحد فنی</td>
          <td>10</td>
          <td>پرداخت نشده</td>
          <td>10,800,000</td>

          <td>
            <strong>€24,71</strong>
          </td>
          <td class="options"><a href="#"></a><a href="#"></a></td>
        </tr>
      </tbody>
    </table>
  </section>
</template>
<script>
export default {};
</script>